import moment from 'moment';
import { Container, Form } from 'semantic-ui-react';
import React, { useEffect, useState } from 'react';
import PDFViews from 'volto-yc-documents/components/PDFViews/PDFViews';
import YCImageView from 'volto-yc-documents/components/YCImageView/YCImageView';
import Helmet from '@plone/volto/helpers/Helmet/Helmet';
import { useDispatch, useSelector } from 'react-redux';
import DefaultLoader from 'volto-yc-documents/components/ContentTypesViews/HelperComponents/DefaultLoader';
import { getUser } from '@plone/volto/actions/users/users';
import jwtDecode from 'jwt-decode';
import RichTextWidget from 'volto-yc-documents/components/Widget/RichText/RichTextWidget';

const OneYorkReliefFundDocListView = (props) => {
  const { content, token } = props;
  const id = jwtDecode(token).sub;
  const dispatch = useDispatch();
  const email = (id) => {
    let response = dispatch(getUser(id));
    let email = response?.email;
    return email;
  };
  const AttachmentSelector = ({ type, file }) => {
    return (
      <div>
        {content?.preview === 'True' ? (
          <div>
            <p>
              <strong> Attachment: </strong>
              {(type && type?.title) ||
                (type && type) ||
                (type && type?.toString()) ||
                (type && type?.token)}{' '}
              - <a href={file?.download}>{file?.filename}</a>
            </p>
            {file ? (
              <PDFViews
                file={file?.download}
                type={file?.['content-type']}
                filename={file?.filename}
              />
            ) : (
              <YCImageView file={file?.scales?.preview?.download} />
            )}{' '}
          </div>
        ) : (
          <p>
            <strong> Attachment: </strong>
            {(type && type?.title) ||
              (type && type) ||
              (type && type?.toString()) ||
              (type && type?.token)}{' '}
            - {file?.filename}
          </p>
        )}
      </div>
    );
  };

  const FieldSelector = ({ label, field }) => {
    if (label && field) {
      return (
        <span>
          <strong>{field && label}: </strong>
          {field && field}
          <br />
        </span>
      );
    }
    return <span>{field && field}</span>;
  };
  const description =
    content?.last_name +
    ', ' +
    content?.first_name +
    ' - ' +
    content?.employeeID;
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    let timer = setTimeout(() => setLoaded(true), 200);
    return () => {
      clearTimeout(timer);
    };
  }, []);
  return (
    <Container>
      {!loaded ? (
        <DefaultLoader active={!loaded} />
      ) : (
        <Form>
          <Helmet title={description} />
          <h1 className="documentFirstHeading">{description}</h1>
          {id && <FieldSelector label="Email" field={email(id)} />}
          {content?.phone_number && (
            <FieldSelector label="Phone Number" field={content?.phone_number} />
          )}
          {content?.address && (
            <FieldSelector label="Address" field={content?.address} />
          )}
          {content?.email && (
            <FieldSelector label="Email Address" field={content?.email} />
          )}
          {content?.prior_assistance_check && (
            <FieldSelector
              label="Have you received emergency assistance from York College before?"
              field={content?.prior_assistance_check?.title}
            />
          )}
          {content?.explanation && (
            <span>
              <strong>
                Brief explanation of your emergency situation & how the funds
                will be used:{' '}
              </strong>
              <RichTextWidget
                className="metadata"
                value={{
                  data: content?.explanation?.data,
                }}
              />{' '}
              <br />
            </span>
          )}
          {content?.request_reason && (
            <FieldSelector
              label="Reason for Request"
              field={content?.request_reason?.title}
            />
          )}
          {content?.financial_aid_check && (
            <FieldSelector
              label="Are you receiving financial aid?"
              field={content?.financial_aid_check?.title}
            />
          )}

          {content?.academic_year?.title && (
            <FieldSelector
              label="Academic Year"
              field={content?.academic_year?.title}
            />
          )}

          {content?.attachment_file && (
            <AttachmentSelector
              type={content?.attachment_type}
              file={content?.attachment_file}
              filename={content?.attachment_file}
            />
          )}

          {content?.attachment_file1 && (
            <AttachmentSelector
              type={content?.attachment_type1}
              file={content?.attachment_file1}
              filename={content?.attachment_file1}
            />
          )}

          {content?.attachment_file2 && (
            <AttachmentSelector
              type={content?.attachment_type2}
              file={content?.attachment_file2}
              filename={content?.attachment_file2}
            />
          )}

          {content?.attachment_file3 && (
            <AttachmentSelector
              type={
                content?.attachment_type3?.title ||
                content?.attachment_type3?.token
              }
              file={content?.attachment_file3}
              filename={content?.attachment_file3}
            />
          )}

          {content?.attachment_file4 && (
            <AttachmentSelector
              type={
                content?.attachment_type4?.title ||
                content?.attachment_type4?.token
              }
              file={content?.attachment_file4}
              filename={content?.attachment_file4}
            />
          )}
          {content?.attachment_file5 && (
            <AttachmentSelector
              type={
                content?.attachment_type5?.title ||
                content?.attachment_type5?.token
              }
              file={content?.attachment_file5}
              filename={content?.attachment_file5}
            />
          )}
          {content?.attachment_file6 && (
            <AttachmentSelector
              type={
                content?.attachment_type6?.title ||
                content?.attachment_type6?.token
              }
              file={content?.attachment_file6}
              filename={content?.attachment_file6}
            />
          )}
          {content?.transcript_file && (
            <AttachmentSelector
              type="Transcript"
              file={content?.transcript_file}
              filename={content?.transcript_file}
            />
          )}
          {content?.degreeworks_file && (
            <AttachmentSelector
              type="DegreeWorks"
              file={content?.degreeworks_file}
              filename={content?.degreeworks_file}
            />
          )}
          {content?.other_file && (
            <AttachmentSelector
              type="other"
              file={content?.other_file}
              filename={content?.other_file}
            />
          )}
          {content?.previous_petition_file && (
            <AttachmentSelector
              type="Previous Petition"
              file={content?.previous_petition_file}
              filename={content?.previous_petition_file}
            />
          )}
          <br />
          <br />
          <p>Created {moment(content?.created).format('ll')}</p>
          <p>Last modified {moment(content?.modified).fromNow('ll')} ago</p>
        </Form>
      )}
    </Container>
  );
};

export default OneYorkReliefFundDocListView;
